export default function getBaseUrl(urlString) {
  const url = new URL(urlString);
  const baseUrl = `${url.protocol}//${url.hostname}${
    url.port ? ':' + url.port : ''
  }`;
  return baseUrl;
}
